// *******************************************************************************
// 1.0 - Secondary Nav
// *******************************************************************************

const secondaryNavContainer = document.querySelector('.secondary-nav');

if (secondaryNavContainer) {
  const secondaryNavHeight = () => {
    const secondaryNav = document.querySelector('.secondary-nav');

    if (secondaryNav) {
      const secondaryNavHeight = `${secondaryNav.offsetHeight}px`;
      document.documentElement.style.setProperty('--secondary-nav-height', secondaryNavHeight);
      document.body.classList.add('has-secondary-nav');
    }
  };

  const toggleSecondaryNav = (toggle) => {
    document.body.classList.toggle('is-open-secondary-nav', toggle);
  };

  secondaryNavHeight();

  window.addEventListener('resize', () => {
    secondaryNavHeight();
  });

  // Toggle Secondary Nav
  attachEvent('.secondary-nav__trigger', 'click', () => {
    const isOpen = document.body.classList.contains('is-open-secondary-nav');
    toggleSecondaryNav(!isOpen);
  });

  // Close Secondary Nav on ESC key press
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      toggleSecondaryNav(false);
    }
  });

  // Close Secondary Nav on Outside Click
  document.addEventListener('click', (evt) => {
    let targetElement = evt.target;

    do {
      if (targetElement === secondaryNavContainer) {
        return;
      }
      targetElement = targetElement.parentNode;
    } while (targetElement);

    toggleSecondaryNav(false);
  });
}
